import request, { PUT } from '../../utils/request';

export default body => request('/ala-agreements', { method: PUT, body });
